/* tslint:disable */
/* eslint-disable */

export interface PwaOrdersMasterDTO {
    homeNotificationModel: HomeNotificationModel;
    enumIbanCountry: EnumIbanCountry;
    bsaOrderPlaceholdersXBVO: BsaOrderPlaceholdersXBVO;
    bsaAuthTokenXBVO: BsaAuthTokenXBVO;
    bsaAuthSessionXBVO: BsaAuthSessionXBVO;
    saldoChangType: SaldoChangeType;
}

export interface HomeNotificationModel {
    entity: HomeNotificationEntity;
    i18nTexts: { [P in Language]?: I18NTextEntity };
}

export interface BsaOrderPlaceholdersXBVO extends BsaResponseXBVO, Serializable {
    orderPlaceholder: BsaOrderPlaceholderXBVO[];
    prepaidSaldo: number;
}

export interface BsaAuthTokenXBVO extends AuthTokenXBVO, Serializable {
    faObjectName: string;
    faObjectNr: string;
    tgRfid: string;
    prepaidActive: boolean;
    incomingMessages: number;
    alertNotification: string;
}

export interface BsaAuthSessionXBVO extends AuthSessionXBVO, Serializable {
    tenantNr: string;
    tenantName: string;
    tgRfid: string;
    userRole: EnumUserRoleType;
    prepaidActive: boolean;
    incomingMessages: number;
    alertNotification: string;
    lastPasswordChange: string;
    placeMultipleOrdersPerMenulineAndServiceday: boolean;
}

export interface SaldoChangeType extends Serializable {
    tableGuestNr: string;
    changeAmount: number;
    changeDate: string;
    changeType: SaldoChangeEnumType;
    bhSaldo: number;
    bhSaldoDate: string;
}

export interface HomeNotificationEntity extends BaseEntity {
    validFrom: Date;
    validTo: Date;
    confirmation: boolean;
    description: string;
}

export interface I18NTextEntity extends BaseEntity {
    textId: number;
    language: Language;
    text: string;
    purpose: I18NTextType;
}

export interface BsaOrderPlaceholderXBVO extends OrderPlaceholderXBVO, Serializable {
    menuAdditives: string;
    dayMessage: string;
    sortOrder: number;
    imageUrl: string;
    menuPrice: number;
}

export interface BsaResponseXBVO extends ResponseXBVO, Serializable {
    prepaidVSaldo: number;
}

export interface Serializable {
}

export interface AuthTokenXBVO extends ResponseXBVO, Serializable {
    token: string;
    refreshToken: string;
}

export interface AuthSessionXBVO extends AuthTokenXBVO, Serializable {
    cpNr: string;
    cpLastname: string;
    cpFirstname: string;
    tgLastname: string;
    tgFirstname: string;
    faObjectName: string;
    faObjectNr: string;
}

export interface BaseEntity extends Serializable, IBaseEntity {
    version: number;
    created: Date;
    modified: Date;
    deleted: number;
    lastModified: Date;
}

export interface OrderPlaceholderXBVO extends Serializable {
    serviceDay: Date;
    menuLine: EnumMenuLineType;
    menuLineDesignation: string;
    menuName: string;
    menuAllergens: string;
    mealType: MealTypeEnum;
    orderPlaced: boolean;
    disableOrdering: boolean;
    disableRemoval: boolean;
    disableReason: string;
    quantity: number;
}

export interface ResponseXBVO extends Serializable {
    code: number;
    error: EnumErrorType;
    errorDescription: string;
}

export interface IBaseEntity {
    id: number;
}

export enum EnumIbanCountry {
    DE = "DE",
    FR = "FR",
    IT = "IT",
    NL = "NL",
    LU = "LU",
    AT = "AT",
    BE = "BE",
    PL = "PL",
    FI = "FI",
    ES = "ES",
    IE = "IE",
    PT = "PT",
    CH = "CH",
    GB = "GB",
    LT = "LT",
    CZ = "CZ",
    DK = "DK",
}

export enum Language {
    DEUTSCH = "DEUTSCH",
    ENGLISH = "ENGLISH",
    POLISH = "POLISH",
}

export enum EnumErrorType {
    E_WEEKSCOUNT_EXCEEDED = "E_WEEKSCOUNT_EXCEEDED",
    E_MAXORDER_NOT_DEFINED = "E_MAXORDER_NOT_DEFINED",
    E_INVALID_MENULINE = "E_INVALID_MENULINE",
    E_BUSINESS_RULE_VIOLATION = "E_BUSINESS_RULE_VIOLATION",
    E_INVALID_PARAMETER = "E_INVALID_PARAMETER",
    E_REFRESH_TOKEN_REQUIRED = "E_REFRESH_TOKEN_REQUIRED",
    E_REFRESH_TOKEN_INVALID = "E_REFRESH_TOKEN_INVALID",
    E_NOT_FOUND = "E_NOT_FOUND",
    E_DISABLED_REGISTRATION = "E_DISABLED_REGISTRATION",
    E_INVALID_LOGIN = "E_INVALID_LOGIN",
    E_INVALID_PASSWORD = "E_INVALID_PASSWORD",
    E_UNAUTHORIZED = "E_UNAUTHORIZED",
}

export enum EnumUserRoleType {
    CP = "CP",
    TG = "TG",
    AD = "AD",
}

export enum SaldoChangeEnumType {
    TOPUP = "TOPUP",
    RK = "RK",
    MONTH_ACCOUNTING = "MONTH_ACCOUNTING",
    CURRENT_BH_SALDO = "CURRENT_BH_SALDO",
    AUTOCHARGE_PENDING = "AUTOCHARGE_PENDING",
    AUTOCHARGE_PROCESSED = "AUTOCHARGE_PROCESSED",
    AUTOCHARGE_CREDITED = "AUTOCHARGE_CREDITED",
}

export enum I18NTextType {
    NOTIFICATION = "NOTIFICATION",
}

export enum EnumMenuLineType {
    MENU_1 = "MENU_1",
    MENU_1_XXL = "MENU_1_XXL",
    MENU_1_D = "MENU_1_D",
    MENU_1_DRINK = "MENU_1_DRINK",
    MENU_1_P_1 = "MENU_1_P_1",
    MENU_2 = "MENU_2",
    MENU_2_VEG = "MENU_2_VEG",
    MENU_2_XXL = "MENU_2_XXL",
    MENU_2_D = "MENU_2_D",
    MENU_3_BIO = "MENU_3_BIO",
    MENU_3 = "MENU_3",
    MENU_4_BIO = "MENU_4_BIO",
    MENU_4 = "MENU_4",
    MENU_5 = "MENU_5",
    MENU_7 = "MENU_7",
    MENU_8 = "MENU_8",
    LUNCH_9 = "LUNCH_9",
    MENU_20 = "MENU_20",
    MENU_20_DESC = "MENU_20_DESC",
    FREEFLOW_1 = "FREEFLOW_1",
    FREEFLOW_1_XXL = "FREEFLOW_1_XXL",
    MILK_1 = "MILK_1",
    MILK_2 = "MILK_2",
    MILK_3 = "MILK_3",
    MILK_4 = "MILK_4",
    DESSERT = "DESSERT",
    DESSERT_2 = "DESSERT_2",
    DESSERT_3 = "DESSERT_3",
    BEVERAGE = "BEVERAGE",
    FRUIT_1 = "FRUIT_1",
    SNACK = "SNACK",
    SALAT_L = "SALAT_L",
    SALAT_1 = "SALAT_1",
    BREAKFAST = "BREAKFAST",
    BREAKFAST_2 = "BREAKFAST_2",
    BREAKTIME = "BREAKTIME",
    SUPPER = "SUPPER",
    DINNER = "DINNER",
    MENU_3_XXL = "MENU_3_XXL",
    MENU_4_XXL = "MENU_4_XXL",
    MENU_5_XXL = "MENU_5_XXL",
    FREEFLOW_2 = "FREEFLOW_2",
    MENU_9 = "MENU_9",
    MENU_10 = "MENU_10",
    MENU_11 = "MENU_11",
    MENU_12 = "MENU_12",
    MENU_13 = "MENU_13",
    PLATE_MENU = "PLATE_MENU",
    PLATE_MENU_FF = "PLATE_MENU_FF",
}

export enum MealTypeEnum {
    BREAKFAST = "BREAKFAST",
    SNACK = "SNACK",
    LUNCH = "LUNCH",
    LUNCH_SIDE = "LUNCH_SIDE",
    BREAKTIME = "BREAKTIME",
    SUPPER = "SUPPER",
    MILK = "MILK",
}
